import { render } from "./CompanyAlignmentCell.vue?vue&type=template&id=fe9a09b4"
import script from "./CompanyAlignmentCell.vue?vue&type=script&lang=js"
export * from "./CompanyAlignmentCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__